import React from "react";
import Head from "next/head";
import Swiper from "swiper";
import "../src/page/downloadCenter.less";
import config from "../src/scripts/config";
import route from "../src/scripts/route";

class DownloadCenter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      appVersion: {},
      timer: null,
    };
  }
  componentDidMount() {
    setTimeout(() => {
      new Swiper(".infoSwiper", {
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 5000,
        },
        pagination: {
          el: ".infoSwiperPagination",
        },
      });
    }, 500);
    clearInterval(this.state.timer);
    this.state.timer = setInterval(() => {
      if (config.appVersion.ios && config.appVersion.android) {
        clearInterval(this.state.timer);
        this.setState({
          appVersion: config.appVersion,
        });
      }
    }, 100);
  }
  render() {
    const appVersion = this.state.appVersion;
    return (
      <div className="downloadCenter">
        <Head>
          <title>下载中心_外汇交易软件-{config.cnName}</title>
          <meta name="keywords" content={`外汇交易软件,${config.cnName}APP,投资软件`} />
          <meta name="description" content={`${config.cnName}应用下载，外汇交易APP下载，包括pc端应用，黄金交易安卓应用，贵金属苹果应用APP下载。`} />
        </Head>
        <div className="content">
          <div className="topic">为您量身定做的BTS交易平台</div>
          <img className="img" src="/static/images/banner-download1.png" />
          <div className="download">
            <div className="button" onClick={route.change.bind(this, "app")}>
              iOS下载
              <br />({appVersion.ios})
            </div>
            <div className="button" onClick={route.change.bind(this, "app")}>
              安卓下载
              <br />({appVersion.android})
            </div>
            {appVersion.google ? (
              <div className="button" onClick={route.change.bind(this, "google")}>
                Google Play商店
                <br />({appVersion.google})
              </div>
            ) : null}
          </div>
          <div className="swiper-container infoSwiper">
            <div className="swiper-wrapper">
              <div className="swiper-slide">
                <img src="/static/images/banner-download3-1.png" alt="" />
                <div className="block">
                  <div className="title">专业图表分析指标</div>
                  <div className="subtitle">主图、副图多指标添加分析，您可以获得价格变动和详细技术分析所需的全部功能。</div>
                </div>
              </div>
              <div className="swiper-slide">
                <img src="/static/images/banner-download3-2.png" alt="" />
                <div className="block">
                  <div className="title">高效订单执行</div>
                  <div className="subtitle">实时行情报价，覆盖全球主流交易所，每秒10万单高性能交易引擎确保交易高效便捷。</div>
                </div>
              </div>
              <div className="swiper-slide">
                <img src="/static/images/banner-home2-2.png" alt="" />
                <div className="block">
                  <div className="title">锁定利润，控制风险</div>
                  <div className="subtitle">限价停损/止盈止损功能，保证金水平预警提醒功能，让您安心交易。</div>
                </div>
              </div>
              <div className="swiper-slide">
                <img src="/static/images/banner-download3-4.png" alt="" />
                <div className="block">
                  <div className="title">新闻快讯透视市场</div>
                  <div className="subtitle">24小时外汇快讯急速推送，掌握行情快人一步，投资动向一目了然。</div>
                </div>
              </div>
            </div>
            <div className="swiper-pagination infoSwiperPagination"> </div>
          </div>
        </div>
        <div className="support">
          <div className="topic">BTS帮助与支持</div>
          <div className="item">
            <img src="/static/images/banner-download2-1.png" alt="" />
            <div className="block">
              <div className="title">专业客服服务</div>
              <div className="subtitle">超快客服响应，专业客服团队，为您解答交易、出入金等问题</div>
            </div>
          </div>
          <div className="item">
            <div className="block">
              <div className="title">模拟交易账户</div>
              <div className="subtitle">免费开设模拟账户交易，快速体验{config.enName2}交易平台</div>
            </div>
            <img src="/static/images/banner-download2-2.png" alt="" />
          </div>
          <div className="item">
            <img src="/static/images/banner-download2-3.png" alt="" />
            <div className="block">
              <div className="title">消息中心</div>
              <div className="subtitle">24小时外汇、黄金等全球金融资讯动态实时推送，让您精准把握投资机会</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DownloadCenter;
